import { Component, ElementRef, HostListener, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'bom-full-page',
  templateUrl: './full-page.component.html',
  styleUrls: ['./full-page.component.scss'],
})
export class FullPageComponent {
  @Input()
  show: boolean;

  @Input() focusTrapping$ = new BehaviorSubject<boolean>(false);

  @Input() bgStyle: 'faded' | 'transparent' = 'faded';

  @Input() empty = false;

  constructor(private el: ElementRef) {}

  @HostListener('window:keydown', ['$event'])
  onkeydown(event: KeyboardEvent) {
    if (this.focusTrapping$.value) {
      const focusable = this.el.nativeElement.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      const firstFocusable = focusable[0];
      const lastFocusable = focusable[focusable.length - 1];

      if (
        window.document.activeElement === firstFocusable &&
        event.shiftKey &&
        event.key === 'Tab'
      ) {
        event.preventDefault();
        lastFocusable.focus();
      }

      if (
        window.document.activeElement === lastFocusable &&
        !event.shiftKey &&
        event.key === 'Tab'
      ) {
        event.preventDefault();
        firstFocusable.focus();
      }
    }
  }
}
